export default __webpack_public_path__ + "static/hackaway-logo-6e5c833fdae40cafe99217db48fae663.png";